import { baseApi } from "@/config/http-common";
import { IRejectRequest } from "@/types/common/entityApproval/EntityApproval";

class EntityApprovalDataService {
  getAll(params?: Record<string, unknown>): Promise<any> {
    return baseApi.get("/common/entity-approval/list", { params });
  }

  get(id: string): Promise<any> {
    return baseApi.get(`/common/entity-approval/view/${id}`);
  }

  approve(id: string): Promise<any> {
    return baseApi.post(`/common/entity-approval/approve/${id}`);
  }

  reject(id: string, data?: IRejectRequest): Promise<any> {
    return baseApi.post(`/common/entity-approval/reject/${id}`, data ?? {});
  }
}

export default new EntityApprovalDataService();
